import React from 'react';
import ReactDOM from 'react-dom/client';
import AppRouter from './components/AppRouter.tsx';
import { ThemeProvider } from './context/ThemeContext.tsx';
import './index.css'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AppRouter />
    </ThemeProvider>
  </React.StrictMode>
);
